import { ArrowRight, Trash2, FileText, Clock } from 'lucide-react';
import {
  conceptStatusLabel,
  conceptTitle,
  type ConceptSession,
} from '../lib/concepts';

interface ConceptListProps {
  concepts: ConceptSession[];
  onContinue: (concept: ConceptSession) => void;
  onDelete: (concept: ConceptSession) => void;
}

export function ConceptList({ concepts, onContinue, onDelete }: ConceptListProps) {
  if (concepts.length === 0) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 text-center py-12">
        <p className="text-xl text-gray-600 mb-2">Je hebt geen concepten</p>
        <p className="text-gray-500">Onafgemaakte blogs verschijnen hier automatisch</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {concepts.map((concept) => (
        <div
          key={concept.id}
          className="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-sm transition-shadow"
        >
          <div className="flex flex-col md:flex-row gap-4">
            {concept.selected_image_url ? (
              <img
                src={concept.selected_image_url}
                alt=""
                className="w-full md:w-40 h-28 object-cover rounded-lg"
              />
            ) : (
              <div className="w-full md:w-40 h-28 rounded-lg bg-gray-100 flex items-center justify-center text-gray-300">
                <FileText className="w-8 h-8" />
              </div>
            )}

            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-2 mb-2">
                <h3 className="text-lg font-semibold text-[#231F20] line-clamp-1">
                  {conceptTitle(concept)}
                </h3>
                <span className="inline-flex items-center px-2 py-1 bg-[#FF6B35]/10 text-[#FF6B35] text-xs font-medium rounded-full whitespace-nowrap">
                  {conceptStatusLabel(concept)}
                </span>
              </div>

              <div className="flex items-center gap-1 text-xs text-gray-500 mb-3">
                <Clock className="w-3 h-3" />
                <span>
                  Laatst bewerkt{' '}
                  {new Date(concept.article_last_edited ?? concept.created_at).toLocaleDateString('nl-NL')}
                </span>
              </div>

              <div className="flex flex-wrap gap-2">
                <button
                  onClick={() => onContinue(concept)}
                  className="btn-primary inline-flex items-center gap-2 text-sm"
                >
                  Verder schrijven
                  <ArrowRight className="w-4 h-4" />
                </button>
                <button
                  onClick={() => onDelete(concept)}
                  className="btn-secondary inline-flex items-center gap-2 text-sm hover:bg-red-50 hover:border-red-200 hover:text-red-600"
                >
                  <Trash2 className="w-4 h-4" />
                  Verwijderen
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
